import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

import LoginPage from './pages/LoginPage';
import HomePage from './pages/HomePage';
import ServiceLinePage from './pages/ServiceLinePage';
import EditPage from './pages/EditPage';
import { authAPI } from './utils/api';

const App = () => {
  const [authStatus, setAuthStatus] = useState({ authenticated: false });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuthStatus();
  }, []);

  const checkAuthStatus = async () => {
    try {
      const status = await authAPI.checkStatus();
      setAuthStatus(status);
    } catch (error) {
      console.error('Auth check failed:', error);
      setAuthStatus({ authenticated: false });
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    try {
      await authAPI.logout();
      setAuthStatus({ authenticated: false });
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="spinner-border text-success" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <div className="App">
        {authStatus.authenticated && (
          <nav className="navbar navbar-expand-lg navbar-box">
            <div className="container-fluid d-flex justify-content-between align-items-center">
              <img 
                src="/assets/images/SagisLogo.png"   
                alt="Logo"
                style={{ height: '80px' }}
              />
              <h2 className='text-navbar-header'>Regional Pathologist Generator</h2>
              <button 
                className="btn btn-logout"
                onClick={handleLogout}               
              >
                Logout
              </button>
            </div>
          </nav>
        )}

        <Routes>
          <Route 
            path="/login" 
            element={
              authStatus.authenticated ? 
                <Navigate to="/dashboard" replace /> : 
                <LoginPage />
            } 
          />
          
          <Route 
            path="/dashboard" 
            element={
              authStatus.authenticated ? 
                <HomePage /> : 
                <Navigate to="/login" replace />
            } 
          />
          
          <Route 
            path="/service/:serviceLine" 
            element={
              authStatus.authenticated ? 
                <ServiceLinePage /> : 
                <Navigate to="/login" replace />
            } 
          />
          
          <Route 
            path="/edit" 
            element={
              authStatus.authenticated ? 
                <EditPage /> : 
                <Navigate to="/login" replace />
            } 
          />
          
          <Route 
            path="/" 
            element={
              <Navigate to={authStatus.authenticated ? "/dashboard" : "/login"} replace />
            } 
          />
        </Routes>

        
      </div>
    </Router>
  );
};

export default App;
